module.exports = __webpack_public_path__ + "img/education2.ae474334.jpg";